
import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Checkbox} from 'primereact/checkbox';
import {Button} from 'primereact/button';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID} from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddFinancialStatementVersion extends Component {
    state = {
        type: 'add',
        Id: null,
        StatementId: '',
        StatementDescription: '',
        IsActive: false,
        statementDetails: [],
        rowSeq: 0,
        createdBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate : new Date(),
        touch : false
    }

    componentDidMount(){
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        // NOTE : 'GeFinancialStatementVersion' is assumed to match the backend table/endpoint
        // name, the same way 'GeAssets' is used in AddAssetMaster. Rename if different.
        // this.props.getMasterTableList('GeFinancialStatementVersion?id='+id);
        let type = this.props.match.params.type;

        if(type !== 'add'){
            this.timer();
        }
    }

    timer = () =>{
        this.intervalID = setInterval(()=> {
            this.fetchSingleProcess();
        },2000)
    }    

    componentWillUnmount(){
        if(this.props.tableLists.financialStatementVersionList!==undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () =>{
        let type = this.props.match.params.type;
        let storageItems = [];
        if(this.props.tableLists.financialStatementVersionList!==undefined) {
            storageItems = this.props.tableLists.financialStatementVersion;
            clearInterval(this.intervalID);
        }
        if(storageItems){
            let filterData = storageItems;
            if(filterData){
                // NOTE : adjust 'filterData.details' / field names below to match the
                // actual API response shape for this master.
                let details = (filterData.details && filterData.details.length>0) ? filterData.details : [];
                let statementDetails = details.map((d) => {
                    return {
                        rowId: d.id,
                        subHeading: d.subHeading,
                        parent: d.parentId,
                        fromAccount: d.fromAccount,
                        toAccount: d.toAccount,
                        showDebit: d.showDebit,
                        showCredit: d.showCredit
                    }
                });
                var data = {
                    type: type,
                    Id: filterData.id,
                    StatementId: filterData.statementId,
                    StatementDescription: filterData.statementDescription,
                    IsActive: filterData.isActive,
                    statementDetails: statementDetails,
                    rowSeq: statementDetails.length
                }
                this.setState(data);
            }
        }
    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})
    }

    /* ───────────────────────────────
        Sub Heading datatable handlers
    ─────────────────────────────── */

    addRow = () => {
        let newRow = {
            rowId: this.state.rowSeq,
            subHeading: '',
            parent: null,
            fromAccount: '',
            toAccount: '',
            showDebit: false,
            showCredit: false
        }
        this.setState({
            statementDetails: [...this.state.statementDetails, newRow],
            rowSeq: this.state.rowSeq + 1,
            touch: true
        });
    }

    removeRow = (rowData) => {
        let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
        let statementDetails = this.state.statementDetails.filter(row => !excludeIds.includes(row.rowId));
        this.setState({statementDetails, touch:true});
    }

    getDescendantIds = (rowId) => {
        let descendants = [];
        let children = this.state.statementDetails.filter(row => row.parent === rowId);
        children.forEach(child => {
            descendants.push(child.rowId);
            descendants = [...descendants, ...this.getDescendantIds(child.rowId)];
        });
        return descendants;
    }

    rowChange = (e, rowData, field) => {
        let value;
        if(field === 'showDebit' || field === 'showCredit'){
            value = e.checked;
        }else if(e.target){
            value = e.target.value;
        }else{
            value = e.value;
        }
        let statementDetails = this.state.statementDetails.map(row => (row.rowId === rowData.rowId) ? {...row, [field]: value} : row);
        this.setState({statementDetails, touch:true});
    }

    getParentOptions = (rowData) => {
        let excludeIds = [rowData.rowId, ...this.getDescendantIds(rowData.rowId)];
        return this.state.statementDetails
            .filter(row => !excludeIds.includes(row.rowId) && row.subHeading !== '')
            .map(row => ({label: row.subHeading, value: row.rowId}));
    }

    buildHierarchy = (flatList) => {
        let map = {};
        flatList.forEach(item => {map[item.rowId] = {...item, children: []}});
        let tree = [];
        flatList.forEach(item => {
            if(item.parent !== null && item.parent !== undefined && map[item.parent]){
                map[item.parent].children.push(map[item.rowId]);
            }else{
                tree.push(map[item.rowId]);
            }
        });
        return tree;
    }

    getDisplayRows = () => {
        let tree = this.buildHierarchy(this.state.statementDetails);
        let flat = [];
        let traverse = (nodes, level) => {
            nodes.forEach(node => {
                flat.push({...node, level});
                if(node.children && node.children.length>0){
                    traverse(node.children, level+1);
                }
            });
        }
        traverse(tree, 0);
        return flat;
    }

    /* ─────────────────
        Column templates
    ───────────────── */

    subHeadingTemplate = (rowData) => {
        return (
            <InputText className="p-col-12" style={{marginLeft: (rowData.level*20)+'px', width: 'calc(100% - '+(rowData.level*20)+'px)'}} value={rowData.subHeading} placeholder="Sub Heading" onChange={(e) => this.rowChange(e, rowData, 'subHeading')} />
        );
    }

    parentTemplate = (rowData) => {
        return (
            <Dropdown className="p-col-12" placeholder="Select Parent" showClear options={this.getParentOptions(rowData)} value={rowData.parent} onChange={(e) => this.rowChange(e, rowData, 'parent')} {...DROPDOWN_CONFIG} />
        );
    }

    fromAccountTemplate = (rowData) => {
        return (
            <InputText className="p-col-12" value={rowData.fromAccount} placeholder="From Account" onChange={(e) => this.rowChange(e, rowData, 'fromAccount')} />
        );
    }

    toAccountTemplate = (rowData) => {
        return (
            <InputText className="p-col-12" value={rowData.toAccount} placeholder="To Account" onChange={(e) => this.rowChange(e, rowData, 'toAccount')} />
        );
    }

    showDebitTemplate = (rowData) => {
        return (
            <Checkbox checked={rowData.showDebit} onChange={(e) => this.rowChange(e, rowData, 'showDebit')} />
        );
    }

    showCreditTemplate = (rowData) => {
        return (
            <Checkbox checked={rowData.showCredit} onChange={(e) => this.rowChange(e, rowData, 'showCredit')} />
        );
    }

    actionTemplate = (rowData) => {
        return (
            <Button icon="pi pi-trash" className="p-button-primary" onClick={() => this.removeRow(rowData)} />
        );
    }

    add = () => {
        if(this.state.StatementId === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'Statement Id is required'});
            return;
        }else if(this.state.StatementDescription === ""){
            this.growl.show({severity: 'error', summary: null, detail: 'Statement Description is required'});
            return;
        }else if(this.state.statementDetails.length === 0){
            this.growl.show({severity: 'error', summary: null, detail: 'Atleast one Sub Heading is required'});
            return;
        }

        for(let row of this.state.statementDetails){
            if(row.subHeading === ""){
                this.growl.show({severity: 'error', summary: null, detail: 'Sub Heading is required for all rows'});
                return;
            }
        }

        var data = {
            StatementId: this.state.StatementId,
            StatementDescription: this.state.StatementDescription,
            IsActive: this.state.IsActive,
            Details: this.buildHierarchy(this.state.statementDetails),
            CreatedBy : this.state.createdBy,
            CreatedDate : this.state.createdDate,
        }

        if(this.state.type === 'edit'){
            data.Id = this.state.Id
        }

        // this.props.processDynamicData('financialStatementVersion',this.state.type,data,'GeFinancialStatementVersion');
        console.log('Submitting data:', data);
    }

    resetData = () => {
        var data = {
            Id: null,
            StatementId: '',
            StatementDescription: '',
            IsActive: false,
            statementDetails: [],
            rowSeq: 0,
            type:'add'
        }
        this.setState(data);
    }
  
    render() {   
        if(this.props.success){
            REDIRECT_TO_URL('/financial-statement-version/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false && this.props.userDetail.userId!==this.props.match.params.id){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/financial-statement-version/';

        return (
            <div className="p-grid">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Financial Statement Version</h1>

                        <div className="p-grid mt1">

                            {/* ════════════════════════════════
                                SECTION 1 : Statement Information
                            ════════════════════════════════ */}
                            <div className="p-col-12">
                                <h3 style={{borderBottom:'2px solid #d0d0d0', paddingBottom:'6px', marginBottom:'10px'}}>Statement Information</h3>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Statement Id <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText className="p-col-12" name="StatementId" placeholder="Statement Id" value={this.state.StatementId} onChange={this.change}/>
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Statement Description <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText className="p-col-12" name="StatementDescription" placeholder="Statement Description" value={this.state.StatementDescription} onChange={this.change}/>
                                </div>
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} value={this.state.IsActive} onChange={this.change} name="IsActive" />
                                </div>
                            </div>

                            {/* ════════════════════════════════
                                SECTION 2 : Sub Headings
                            ════════════════════════════════ */}
                            <div className="p-col-12" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                                <h3 style={{borderBottom:'2px solid #d0d0d0', paddingBottom:'6px', marginBottom:'10px', marginTop:'10px', flex:1}}>Sub Headings</h3>
                                <Button label="Add Row" icon="pi pi-plus" className="p-button-success" onClick={this.addRow} style={{marginLeft:'10px'}} />
                            </div>

                            <div className="p-col-12">
                                <DataTable value={this.getDisplayRows()} dataKey="rowId" responsiveLayout="scroll">
                                    <Column field="subHeading" header="Sub Heading" body={this.subHeadingTemplate} />
                                    <Column field="parent" header="Parent" body={this.parentTemplate} />
                                    <Column field="fromAccount" header="From Account" body={this.fromAccountTemplate} />
                                    <Column field="toAccount" header="To Account" body={this.toAccountTemplate} />
                                    <Column field="showDebit" header="Show Debit" body={this.showDebitTemplate} />
                                    <Column field="showCredit" header="Show Credit" body={this.showCreditTemplate} />
                                    <Column header="Action" body={this.actionTemplate} />
                                </DataTable>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddFinancialStatementVersion);